import type { LocalDatabase } from '../core/types';
import type { QueryBuilderSpec } from '~/powersync/types';
import type {
  MuscleTargetRecord,
  SportActivityCategoryRecord,
  SportActivityRecord,
} from '~/powersync/generated/schema';

export const SportActivityQueries = {
  findById: (id: string | null | undefined): QueryBuilderSpec<unknown> => ({
    createQuery: id
      ? (db: LocalDatabase) =>
          db
            .selectFrom('SportActivity')
            .selectAll()
            .where('id', '=', id)
            .where('deletedAt', 'is', null)
      : null,
    queryKey: ['sport-activity', 'id', id ?? 'null'],
  }),

  findByIds: (ids: string[]): QueryBuilderSpec<SportActivityRecord> => ({
    createQuery:
      ids.length > 0
        ? (db: LocalDatabase) =>
            db
              .selectFrom('SportActivity')
              .selectAll()
              .where('id', 'in', ids)
              .where('deletedAt', 'is', null)
        : null,
    queryKey: ['sport-activity', 'ids', ...[...ids].sort()],
  }),

  findMuscleTargets: (sportActivityId: string): QueryBuilderSpec<unknown> => ({
    createQuery: (db: LocalDatabase) =>
      db
        .selectFrom('MuscleTarget')
        .selectAll()
        .where('sportActivityId', '=', sportActivityId),
    queryKey: ['sport-activity', 'muscle-targets', sportActivityId],
  }),

  findMuscleTargetsBySportActivityIds: (
    ids: string[],
  ): QueryBuilderSpec<MuscleTargetRecord> => ({
    createQuery:
      ids.length > 0
        ? (db: LocalDatabase) =>
            db
              .selectFrom('MuscleTarget')
              .selectAll()
              .where('sportActivityId', 'in', ids)
        : null,
    queryKey: ['sport-activity', 'muscle-targets', 'ids', ...[...ids].sort()],
  }),

  findCategoryById: (
    categoryId: string | null | undefined,
  ): QueryBuilderSpec<SportActivityCategoryRecord> => ({
    createQuery: categoryId
      ? (db: LocalDatabase) =>
          db
            .selectFrom('SportActivityCategory')
            .selectAll()
            .where('id', '=', categoryId)
      : null,
    queryKey: ['sport-activity', 'category', 'id', categoryId ?? 'null'],
  }),

  findByUserId: (
    userId: string | null | undefined,
  ): QueryBuilderSpec<SportActivityRecord> => ({
    createQuery: userId
      ? (db: LocalDatabase) =>
          db
            .selectFrom('SportActivity')
            .selectAll()
            .where('userId', '=', userId)
            .where('deletedAt', 'is', null)
            .orderBy('createdAt', 'desc')
      : null,
    queryKey: ['sport-activity', 'userId', userId ?? 'null'],
  }),

  findAllCategories: (): QueryBuilderSpec<SportActivityCategoryRecord> => ({
    createQuery: (db: LocalDatabase) =>
      db
        .selectFrom('SportActivityCategory')
        .selectAll()
        .where('deletedAt', 'is', null),
    queryKey: ['sport-activity', 'categories', 'all'],
  }),
};
